import React, { useCallback } from 'react';

import { useIntl } from '@futrli/localisation';

import { ExtendedLiveReportList } from '@futrli/views/processors/dashboards/dashboardsList';

import { CreateDashboardButton } from '../create-dashboard-button/create-dashboard-button';
import { MyDashboardRow, ROW_HEIGHT_DEFAULT } from '../my-dashboard-row/my-dashboard-row';
import { useDashboardActions } from '../../context/dashboard-actions-context/dashboard-actions-context';
import { VirtualizedCardListEmptyState } from '../../../ui/virtualized-card-list/virtualized-card-list-empty-state';
import { VirtualizedCardList } from '../../../ui/virtualized-card-list/virtualized-card-list';

interface MyDashboardListProps {
  data?: ExtendedLiveReportList[];
  isEmpty?: boolean;
  isLoading?: boolean;
  isResourceSharingEnabled?: boolean;
}

export const MyDashboardList = ({
  data = [],
  isEmpty = false,
  isLoading = false,
  isResourceSharingEnabled = false
}: MyDashboardListProps) => {
  const intl = useIntl();
  const { handleNameClick } = useDashboardActions();

  const renderRow = useCallback(
    (item: ExtendedLiveReportList) => {
      return (
        <MyDashboardRow
          dashboard={item}
          isResourceSharingEnabled={isResourceSharingEnabled}
          onNameClick={() => handleNameClick(item)}
        />
      );
    },
    [handleNameClick, isResourceSharingEnabled]
  );

  const rowHeight = useCallback(() => ROW_HEIGHT_DEFAULT, []);

  return (
    <VirtualizedCardList<ExtendedLiveReportList>
      data={data}
      renderRow={renderRow}
      rowHeight={rowHeight}
      isLoading={isLoading}
      emptyState={
        <VirtualizedCardListEmptyState
          title={intl.formatMessage({
            id: 'predict.dashboards.no_dashboards',
            defaultMessage: 'No dashboards to show'
          })}
          description={
            isEmpty
              ? intl.formatMessage({
                  id: 'predict.dashboards.get_started_with_dashboard',
                  defaultMessage: 'Get started with your first dashboard'
                })
              : undefined
          }
          action={isEmpty ? <CreateDashboardButton variant="secondary" /> : undefined}
        />
      }
    />
  );
};
